import { useEffect } from 'react';
import { isEmpty } from 'validate.js';

const useFabricTitle = (product) => {
  const suffix = 'Shop | Fabrics | AskOkey';
  let title = '';
  if (isEmpty(product)) {
    title = suffix;
  } else {
    title = product.name + ' | ' + suffix;
  }

  useEffect(() => {
    document.title = title;
  });
};

export default useFabricTitle;
